import React from 'react';
import cx from 'classnames';
import {Row, Col} from '@/grid';
import HubspotForm from '@/ui/hubspotform';
import {PNoMargin, H3} from '@/typography';
import {withMarginBottomSm, withMarginTopMd} from '@/hocs/withSpacing';
import FormsHandler from '@/formshandler/index';
import Container from '@/container';
import {withBgOrange50} from '@/hocs/withColors';
import {withXSmall} from '@/hocs/withFontType';
import styles from './terms-form.module.scss';

const H3Margined = withMarginTopMd(withMarginBottomSm(H3));
const Orange50Container = withBgOrange50(Container);
const PNoMarginXs = withXSmall(PNoMargin);

const TermsForm = () => (
  <div className={cx(styles.divider, 'no-print')}>
    <Orange50Container className={styles['orange-container']}>
      <div className={styles['footer-newsletter-inner']}>
        <Row center="xs" middle="xs">
          <Col lg={6} md={8} sm={10}>
            <div className={styles['newsletter-container']}>
              <H3Margined>Stay up-to-date on our updates</H3Margined>
              <PNoMarginXs>
                Occasionally, we need to update our Terms or Sub-processors. If you’d like to
                receive an email notification when we do, just tell us where to send it:
              </PNoMarginXs>
              <div id="form" className="hs-form form-inline form-animated">
                <HubspotForm
                  portalId={process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID}
                  formId={process.env.NEXT_PUBLIC_TERMS_FORM_ID}
                  css=""
                  onFormError={FormsHandler.handleFormError}
                  onFormReady={() => {
                    FormsHandler.handleFormReady();

                    FormsHandler.handleInputFocus(process.env.NEXT_PUBLIC_TERMS_FORM_ID);

                    FormsHandler.populateGCLIDValue();

                    FormsHandler.populateMetroValue();
                  }}
                  onFormSubmitted={() => {
                    if (window.dataLayer) {
                      window.dataLayer.push({
                        event: 'Event',
                        eventCategory: 'Form',
                        eventAction: 'Submitted',
                        eventLabel: 'Terms Form'
                      });
                    }
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Orange50Container>
  </div>
);

export default TermsForm;
